import { FC } from 'react';

interface DailyLimitModalProps {
  errorMessage: string;
  onClose: () => void;
}

const DailyLimitModal: FC<DailyLimitModalProps> = ({ errorMessage, onClose }) => {
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[9998]" />

      {/* Modal */}
      <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-xl max-w-lg w-full p-8">
          <h2 className="text-2xl font-bold mb-4 text-gray-900">Daily Limit Reached</h2>
          <p className="text-base text-gray-700 mb-6 whitespace-pre-line">{errorMessage}</p>
          <button
            onClick={onClose}
            className="w-full bg-[#2B3440] hover:bg-[#3d4559] text-white px-6 py-3 rounded-xl font-medium"
          >
            Got it
          </button>
        </div>
      </div>
    </>
  );
};

export default DailyLimitModal;
